import query from '../../GraphQL/Checkout/productActivities'
import GraphQLRequest from '../GraphQLClient/GraphQLClient'

import { StorageAccessor } from 'Utilities/LocalStorageUtility/LocalStorageUtility'

const getProductActivity = async (skuBases) => {
  const results = []
  try {
    if (!skuBases?.length) {
      return results
    }

    skuBases = [...new Set(skuBases)]

    const { found: basesFound, toFetch: basesToFetch } = TryGetProductActivityFromCache(skuBases)

    let fetchResponse = []

    if (basesToFetch?.length) {
      const variables = {
        request: {
          skuBases: basesToFetch,
        },
      }
      fetchResponse = await GraphQLRequest('/graphql/checkout', query, variables)
    }

    const allProductActivities = [...(fetchResponse?.productActivity?.productActivity ?? [])]

    // UpdateProductActivitiesCache(
    //     fetchResponse?.productActivities ?? [],
    //     skuBases
    // );

    return allProductActivities
  } catch (err) {
    console.error('error fetching shipping estimate', err)
  }

  return results
}

export default getProductActivity

const getKey = (keyBase) => `ProductActivity_${keyBase}`
const MINUTES = 60

const TryGetProductActivityFromCache = (skuBasesOrVariants) => {
  const found = []
  const toFetch = []
  for (let i = 0, ilen = skuBasesOrVariants.length; i < ilen; i++) {
    const thisOne = StorageAccessor.sessionStorage.getObj(getKey(skuBasesOrVariants[i]))

    if (thisOne) {
      found.push(thisOne)
    } else {
      toFetch.push(skuBasesOrVariants[i])
    }
  }

  return { found, toFetch }
}

const UpdateProductActivitiesCache = (productActivities, skuBases) => {
  for (let i = 0, ilen = productActivities.length; i < ilen; i++) {
    const useVariant = skuBases.includes(productActivities[i].skuVariantUsed)
    const keyBase = useVariant ? productActivities[i].skuVariantUsed : productActivities[i].skuBase

    StorageAccessor.sessionStorage.setObj(getKey(keyBase), productActivities[i], MINUTES)
  }
}
